
import {
  Vue,
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Button,
  Input,
} from 'element-ui';
import tEditor from '@/components/Editor/editor.vue';
import api from '@/api/match';
import Draggable from 'vuedraggable';

@Component({
  components: {
    Form,
    FormItem,
    Button,
    Input,
  },
})

export default class secondStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  @Prop({
    required: true,
    default: false,
  }) title!: any;

  private form: any = {
  };


  private rules: any = {}

  public $refs!: {
    form: Form,
  };

  mounted() {
    if (this.title.includes('修改')) {
      this.form = {
        backdropLibrary: this.oldForm.backdropLibrary,
        costumeLibrary: this.oldForm.costumeLibrary,
        soundLibrary: this.oldForm.soundLibrary,
        spriteLibrary: this.oldForm.spriteLibrary,
      };
    }
  }

  /**
   * @author liangyongmou
   * @desc 提交
   * @param 空
   */
  handleSubmit() {
    // eslint-disable-next-line array-callback-return
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        result = this.form;
      }
    });
    return result;
  }
}
